export default "__VITE_ASSET__BZLztQKs__"